import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";

import LogoPrincipal from "../../images/LogoKeraunos.png";

const useStyles = makeStyles((theme) => ({
  imageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  img: {
    maxWidth: "100%",
  },
}));

/**
 * Component to logo
 */
export const LogoKerunos = ({ image = LogoPrincipal }) => {
  const classes = useStyles();
  return (
    <div className={classes.imageContainer}>
      <img src={image} alt="img" className={classes.img} />
    </div>
  );
};

LogoKerunos.propTypes = {
  /**
   * to set image
   */
  image: PropTypes.string,
};
